<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between gap-3">
    <div class="text-semi-bold" i18n>Products List</div>
    <div class="flex-fill"></div>
    <app-table-search (search)="onSearch($event)"></app-table-search>
    <button
      class="btn btn-secondary-primary"
      (click)="onRefresh()"
      i18n-matTooltip
      matTooltip="Refresh List"
      matTooltipPosition="above"
    >
      <i class="far fa-sync"></i>
    </button>
    <button type="button" class="btn btn-secondary-info" (click)="onAdd()">
      <i class="far fa-plus"></i> <ng-container i18n>Add Product</ng-container>
    </button>
  </div>

  <div class="table-holder table-responsive">
    <table class="table table-default">
      <mat-table #table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="propertyName">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Property Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.propertyName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="roomName">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Room Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.roomName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rateName">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Rate Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.rateName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef i18n> Edit </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div dropdown placement="bottom right" container="body">
              <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                <a class="btn-ellips">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li>
                  <button (click)="onRemove(element)" type="button">
                    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
                  </button>
                </li>
              </ul>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></mat-row>
      </mat-table>
      <app-loading-section *ngIf="isLoading"></app-loading-section>
      <mat-paginator2
        #paginator
        [length]="dataSource?.data?.length"
        [class.hidden]="!dataSource?.filteredData?.length"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>
      <app-empty-table *ngIf="!isLoading && isEmptyTable$ | async">
        <img class="empty-image" src="assets/images/empty_icons/bdc-photo.svg" />
        <h5 class="empty-header" i18n>Organize and Manage Your Listings with Ease</h5>
        <p>
          <ng-container i18n
            >Start building your property rate plans by adding products linked to rooms and rates.</ng-container
          >&nbsp; <a href="javascript:void(0)" (click)="onAdd()" i18n>Click here</a>&nbsp;<ng-container i18n
            >to add your first product and streamline your setup today.</ng-container
          >
        </p>
      </app-empty-table>
    </table>
  </div>
</div>
